import { NavLink } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';

interface AppNavProps {
    isOpen: boolean;
    isAdmin?: boolean;
}

const AppNav = ({ isOpen }: AppNavProps) => {
    const { instance, accounts } = useMsal();
    const account = instance.getActiveAccount() || accounts[0];

    const handleSignOut = () => {
        try {
            // Clear MSAL cache
            instance.clearCache();
            // Clear activity tracking
            localStorage.removeItem("idle:lastActivity");
            localStorage.removeItem("idle:forceLogoutAt");
            // Redirect to home
            window.location.assign("/");
        } catch (err) {
            console.error(err);
            window.location.assign("/");
        }
    };

    return (
        <div className={'nav ' + (isOpen ? 'nav--active' : '')}>
            <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>Home</NavLink>
            <NavLink to="/myaccount" className={({ isActive }) => isActive ? 'active' : ''}>View MyAccount</NavLink>
            {/* <NavLink to="/reportarepair" className={({ isActive }) => isActive ? 'active' : ''}>Report a repair</NavLink> */}
            <a href="https://www.accentgroup.org/your-home/repairs-and-maintenance/" target="_blank" rel="noopener noreferrer">Report a repair</a>
            <NavLink to="/myrepairs" className={({ isActive }) => isActive ? 'active' : ''}>View repairs</NavLink>
            <NavLink to="/mydocuments" className={({ isActive }) => isActive ? 'active' : ''}>View documents</NavLink>
            <NavLink to="/myprofile" className={({ isActive }) => isActive ? 'active' : ''}>View profile</NavLink>
            {/* <NavLink to="/antisocialbehaviour" className={({ isActive }) => isActive ? 'active' : ''}>Report anti-social behaviour</NavLink> */}
            <a href="https://www.accentgroup.org/your-home/anti-social-behaviour/report-difficult-behaviour-in-your-area/" target="_blank" rel="noopener noreferrer" className="external-link">Report anti-social behaviour</a>
            {/* <NavLink to="/contactus" className={({ isActive }) => isActive ? 'active' : ''}>Contact us</NavLink> */}
            <a href="https://www.accentgroup.org/contact-us/" target="_blank" rel="noopener noreferrer" className="external-link">Contact us</a>

            {account && (
                <button className="btn logout" onClick={handleSignOut}>
                    Log out
                </button>
            )}
        </div>
    );
};

export default AppNav;
